<!-- 规则 -->
<template>
    <div id='serviceRankingList-rules'>
        <div v-if="$route.query.isStore == 5">
            <img v-if="$route.query.currentJobTab == '2' || $route.query.currentJobTab == '3' || $route.query.currentJobTab == '1'" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2026-01-04/rulesYm1.png`" alt="">
            <img v-if="$route.query.currentJobTab == '3' || $route.query.currentJobTab == '1'" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2026-01-04/rulesYm2.png`" alt="">
        </div>
        <div v-else>
            <img v-if="$route.query.currentJobTab == '2'" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2026-01-04/rulesYm3.png`" alt="">
            <img v-else-if="$route.query.currentJobTab == '3'" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2026-01-04/rulesYm4.png`" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ssRules',
        components: {},

        computed: {},

        data() {
            return {
            };
        },

        mounted() { },

        methods: {}
    }

</script>
<style lang='less' scoped>
    #serviceRankingList-rules {
        width: 100%;
        height: 100vh;
        overflow: auto;
        padding-bottom: 20px;
    }

    #serviceRankingList-rules img {
        width: 100%;

    }
</style>